import * as api from '../coOpApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import {
  coOpActionCreators,
  CoOpActionKeys,
  FetchCoOpRegionBudgets,
  ICoOpRegionBudget
  } from '..';
import { uiActionCreators } from '../../ui';
import {} from '../coOpInterfaces';

function* fetchCoOpRegionBudgetsSaga(action: FetchCoOpRegionBudgets) {
  yield put(uiActionCreators.toggleLoading('coOpRegionBudgets'));
  const response: ICoOpRegionBudget[] = yield call(api.fetchCoOpRegionBudgets, action.payload.fiscalYear);

  yield put(coOpActionCreators.setRegionBudgets(response));
  yield put(uiActionCreators.toggleLoading('coOpRegionBudgets'));
}

export function* watchFetchCoOpRegionBudgets() {
  yield takeEvery(CoOpActionKeys.FETCH_COOP_REGION_BUDGETS, fetchCoOpRegionBudgetsSaga);
}
